import { isValid as isValidIban } from "iban";
import * as z from "zod";

// valid iban for testing countries(GB, NO, SE, DK)
// GB42 UDKA 0506 5873 3383 78, NO31 5285 0485 372, SE8381236337554571917580, DK53 7664 9488 2565 66
// valid bank account number is between (8-20) numbers

const validationSchema = z.object({
  name: z.preprocess((v) => v ?? "", z.string().min(1, { message: "validation:bankAccountNameRequired" })),
  accountNo: z.preprocess(
    (v) => v ?? "",
    z
      .string()
      .min(1, { message: "validation:bankAccountNumberRequired" })
      .regex(/^\d{8,20}$/, "validation:bankAccountWrongFormat")
  ),
  iban: z.preprocess(
    (v) => v ?? "",
    z.string().min(1, { message: "validation:ibanRequired" }).refine(isValidIban, {
      message: "validation:ibanFormatError",
    })
  ),
});

export const BankAccountValidationSchema = validationSchema;
export type BankAccountFormInput = z.infer<typeof BankAccountValidationSchema>;
